var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "footer__newsletter" },
    [
      _c("h5", [_vm._v("Nieuwsbrief")]),
      _vm._v(" "),
      _c("validation-observer", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var handleSubmit = ref.handleSubmit
              return [
                _c(
                  "form",
                  {
                    ref: "newsletterform",
                    staticClass: "form",
                    attrs: {
                      action:
                        "https://reveil.us14.list-manage.com/subscribe/post?u=5fae56310f5dacbd1a8a4c760&id=7c4ed9fa7b",
                      id: "mc-embedded-subscribe-form",
                      method: "post",
                      name: "mc-embedded-subscribe-form",
                      target: "_blank"
                    },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.onSubmit)
                      }
                    }
                  },
                  [
                    _c("input", {
                      attrs: {
                        id: "mce-group[408182]-408182-0",
                        name: "group[408182]",
                        type: "hidden",
                        value: "4096"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "newsletter-form",
                        attrs: { id: "mc_embed_signup_scroll" }
                      },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required|email" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mc-field-group newsletter-form__main"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.newsletterMail,
                                              expression: "newsletterMail"
                                            }
                                          ],
                                          staticClass: "required h-full",
                                          class: errors.length ? "error" : "",
                                          attrs: {
                                            id: "mce-EMAIL",
                                            name: "EMAIL",
                                            type: "email",
                                            value: ""
                                          },
                                          domProps: {
                                            value: _vm.newsletterMail
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.newsletterMail =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("input", {
                                          staticClass: "btn",
                                          attrs: {
                                            id: "mc-embedded-subscribe",
                                            name: "subscribe",
                                            type: "submit",
                                            value: "Verzend"
                                          },
                                          on: { click: _vm.checkConsent }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: errors.length,
                                            expression: "errors.length"
                                          }
                                        ],
                                        staticClass: "error-msg"
                                      },
                                      [_vm._v(_vm._s(errors[0]))]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              position: "absolute",
                              left: "-5000px"
                            },
                            attrs: { "aria-hidden": "true" }
                          },
                          [
                            _c("input", {
                              attrs: {
                                name: "b_5fae56310f5dacbd1a8a4c760_7c4ed9fa7b",
                                tabindex: "-1",
                                type: "text",
                                value: ""
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "newsletter-form__disclaimer" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newsletterConsent.val,
                                  expression: "newsletterConsent.val"
                                }
                              ],
                              attrs: {
                                hidden: "hidden",
                                id: "newsletter-disclaimer",
                                type: "checkbox"
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.newsletterConsent.val
                                )
                                  ? _vm._i(_vm.newsletterConsent.val, null) > -1
                                  : _vm.newsletterConsent.val
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.newsletterConsent.val,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.newsletterConsent,
                                            "val",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.newsletterConsent,
                                            "val",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.newsletterConsent,
                                        "val",
                                        $$c
                                      )
                                    }
                                  },
                                  _vm.removeConsentError
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "newsletter-disclaimer" } },
                              [
                                _vm._v(
                                  "Ik ga akkoord met de privacy disclaimer"
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.newsletterConsent.showError,
                                expression: "newsletterConsent.showError"
                              }
                            ],
                            staticClass: "error-msg"
                          },
                          [
                            _vm._v(
                              "Gelieve akkoord te gaan met de privacy disclaimer."
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }